module.exports = __webpack_public_path__ + "static/media/squared.8160d5ee.jpg";